import { render, staticRenderFns } from "./readBook.vue?vue&type=template&id=6f0bd57e&scoped=true&"
import script from "./readBook.vue?vue&type=script&setup=true&lang=js&"
export * from "./readBook.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./readBook.vue?vue&type=style&index=0&id=6f0bd57e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0bd57e",
  null
  
)

export default component.exports